"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireWildcard(require("react"));

var _atom = require("atom");

var _UIAvatar = _interopRequireDefault(require("ui-addon-avatars/UIAvatar"));

var _ReferenceResolverType = _interopRequireDefault(require("reference-resolvers/schema/ReferenceResolverType"));

var _ObjectRecordAccessors = require("customer-data-objects/record/ObjectRecordAccessors");

var _ObjectRecordFormatters = require("customer-data-objects/record/ObjectRecordFormatters");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var propTypes = {
  resolver: _ReferenceResolverType.default.isRequired,
  value: _react.PropTypes.string,
  'data-selenium-test': _react.PropTypes.string
};

var PropertyInputAssociatedCompany =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PropertyInputAssociatedCompany, _React$Component);

  function PropertyInputAssociatedCompany(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PropertyInputAssociatedCompany);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputAssociatedCompany).call(this, props));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      company: null
    };
    return _this;
  }

  (0, _createClass2.default)(PropertyInputAssociatedCompany, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleInitReferenceAtom();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.referenceAtom) {
        (0, _atom.unwatch)(this.referenceAtom, this.handleCompanyReferenceChange);
      }
    }
  }, {
    key: "handleInitReferenceAtom",
    value: function handleInitReferenceAtom() {
      var _this$props = this.props,
          resolver = _this$props.resolver,
          value = _this$props.value;

      if (!value) {
        return;
      }

      this.referenceAtom = resolver.byId(value);
      (0, _atom.watch)(this.referenceAtom, this.handleCompanyReferenceChange);
      this.handleCompanyReferenceChange((0, _atom.deref)(this.referenceAtom));
    }
  }, {
    key: "handleCompanyReferenceChange",
    value: function handleCompanyReferenceChange(reference) {
      if (!reference) {
        return;
      }

      var company = reference.referencedObject;

      if (!company) {
        return;
      }

      this.setState({
        company: company
      });
    }
  }, {
    key: "render",
    value: function render() {
      var company = this.state.company;
      var domain = company && (0, _ObjectRecordAccessors.getProperty)(company, 'domain');
      return company ? _react.default.createElement("div", {
        "data-selenium-test": this.props['data-selenium-test']
      }, _react.default.createElement(_UIAvatar.default, {
        className: "m-y-2 m-right-3",
        lookup: {
          type: 'domain',
          primaryIdentifier: domain
        },
        size: "sm"
      }), _react.default.createElement("span", null, ' ', "" + (0, _ObjectRecordFormatters.toString)(_I18n.default.formatName, company), domain ? "(" + domain + ")" : '')) : _react.default.createElement("div", null);
    }
  }]);
  return PropertyInputAssociatedCompany;
}(_react.default.Component);

PropertyInputAssociatedCompany.propTypes = propTypes;
var _default = PropertyInputAssociatedCompany;
exports.default = _default;
module.exports = exports.default;